import { APP_INITIALIZER, Provider } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { initializeLinkStyle } from '@qaroni-core/utils/scripts/limk-style';
import { initializeMetaTags } from '@qaroni-core/utils/scripts/meta-tags';
import { initializeMapScript } from '@qaroni-core/utils/scripts/script-map';

export const providersInitialize = (): Provider[] => {
  return [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeLinkStyle,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMetaTags,
      deps: [Meta],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMapScript,
      multi: true,
    },
  ];
};
